import { assign } from "lodash-es";
import { identity } from "lodash-es";
export default function adjustRangeToRotation(rangeToBeAdjusted, rotateTo = 0, rangeLength) {
  const mod = rangeLength ? modulo : identity;
  const newRange = assign({}, rangeToBeAdjusted, {
    start: mod(rangeToBeAdjusted.start - (rotateTo || 0), rangeLength),
    end: mod(rangeToBeAdjusted.end - (rotateTo || 0), rangeLength)
  });
  return newRange;
}
function modulo(n, m) {
  return (n % m + m) % m;
}
